'use client'

import { useScreenMatch } from 'lib/utilities/screens'
import FastMarquee from 'react-fast-marquee'
import Header from '../Header/Header'
import Logo, { Brand } from '../Logo/Logo'
import PageSection from '../PageSection/PageSection'

export interface MarqueeProps {
  /**
   * Title of the marquee.
   */
  title: string
  /**
   * List of logos to display.
   */
  logos: Brand[]
}

export default function Marquee({ title, logos }: MarqueeProps) {
  const isTablet = useScreenMatch('md')

  return (
    <PageSection className="bg-white">
      <div className=" py-14 w-full overflow-hidden">
        <Header as="h2" className="type-body-2 !font-normal text-center mb-8">
          {title}
        </Header>
        <FastMarquee
          autoFill
          className="[&_.rfm-child]:mr-[5.625rem] [&_.rfm-child]:md:mr-[7.5rem]"
        >
          <ul className="inline-flex items-center justify-start gap-[5.625rem] md:gap-[7.5rem]">
            {logos.map((logo, key) => (
              <li key={key}>
                <Logo
                  brand={logo as Brand}
                  width="auto"
                  height={isTablet ? '32' : '24'}
                />
              </li>
            ))}
          </ul>
        </FastMarquee>
      </div>
    </PageSection>
  )
}
